<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <section class="modal-card-body">
        <div>
          <div v-if="action === 'activate'">
            <b-message type="is-success">
              Are you sure you want to activate this delivery? After a delivery has been activated,
              it can no longer be changed without an approved revision.
            </b-message>
          </div>
          <div v-if="action === 'pause'">
            <b-message type="is-warning">
              Are you sure you want to pause this delivery?
            </b-message>
          </div>
          <div v-else-if="action === 'restart'">
            <b-message type="is-warning">
              Are you sure you want to restart this delivery?
            </b-message>
          </div>
          <div v-else-if="action === 'archive'">
            <b-message type="is-danger">
              Are you sure you want to remove this delivery?
            </b-message>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >{{ actionLabel }}</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api', 'context']),
    method () {
      switch (this.action) {
        case 'archive':
          return 'delete'
        default:
          return 'put'
      }
    },
    endpoint () {
      const base = this.api.route + '/projects/' + this.project.id + '/deliveries/' + this.delivery.id
      switch (this.action) {
        case 'activate':
          return base + '/actions/activate'
        case 'pause':
          return base + '/actions/pause'
        case 'restart':
          return base + '/actions/restart'
        default:
          return base
      }
    },
    actionLabel () {
      switch (this.action) {
        case 'activate':
          return 'Activate Delivery?'
        case 'pause':
          return 'Pause Delivery?'
        case 'restart':
          return 'Restart Delivery'
        case 'archive':
          return 'Remove Delivery?'
        default:
          return 'Edit Delivery'
      }
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http[this.method](this.endpoint, this.json).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Project updated!' })
        this.$emit('delivery:saved')
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  props: {
    project: {
      type: Object,
      required: true
    },
    delivery: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  }
}
</script>
